import { get } from 'lodash';
import { useMemo } from 'react';
import { useQuery } from 'react-apollo';
import assetConditionsSelector from './data/assetConditionsSelector.graphql';
export default function useAssetConditionsSelector() {
    const queryRes = useQuery(assetConditionsSelector, {
        fetchPolicy: 'cache-first',
    });
    const assetConditions = useMemo(() => get(queryRes, 'data.assetConditionsSelector', []), [queryRes]);
    return {
        assetConditions,
        error: queryRes.error,
        loading: queryRes.loading,
    };
}
// eslint-disable-next-line no-magic-numbers
export const DefaultAssetConditionsFilter = [1, 2, 3, 4];
export const DefaultAssetConditionsEntity = 1;
